import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#loan-amount-calculator-app', App);
